export const clearMobileSession = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("bow_accessToken");
};
